import { useQuery } from '@apollo/client';
import { GET_PROPOSAL_STATUSES_OPTIONS } from '../api';
import { SelectOption } from '../../../global';

export function useProposalStatusesOptions() {
  const { data, loading } = useQuery<{ proposalStatuses: SelectOption[] }>(GET_PROPOSAL_STATUSES_OPTIONS);

  return {
    isLoading: loading,
    options: data?.proposalStatuses ?? [],
  };
}
